<nb-card [nbSpinner]="loading" nbSpinnerStatus="info">
  <nb-card-header>
    <div>
      <button
        [ngClass]="menu == 'info' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'info' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltipPlacement="bottom"
        (click)="selectMenu('info')"
      >
        <nb-icon class="button-icon" icon="info-outline"></nb-icon>
        <span>{{ "common.info" | translate }}</span>
      </button>

      <!-- <button
        [ngClass]="menu == 'content' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'content' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltip="{{'common.moreDetail' | translate}}"
        nbTooltipPlacement="bottom"
        (click)="selectMenu('content')"
      >
        <nb-icon class="button-icon" icon="file-text-outline"></nb-icon>
        <span>{{'common.moreDetail' | translate}}</span>
      </button> -->
    </div>

    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <div class="row" *ngIf="menu == 'info'">
      <div class="col-12 col-md-6">
        <form [formGroup]="diaForm">
          <div class="form-group">
            <label class="label">{{ "product.barcode" | translate }} </label>
            <input
              type="text"
              nbInput
              fullWidth
              class="form-control"
              placeholder="{{ 'product.barcode' | translate }}"
              formControlName="barcode"
              [(ngModel)]="product.barcode"
            />
          </div>

          <div class="form-group">
            <label for="inputTitle" class="label text-primary">{{
              "product.name" | translate
            }}</label>
            <input
              type="text"
              nbInput
              fullWidth
              class="form-control"
              placeholder="{{ 'product.name' | translate }}"
              id="title"
              formControlName="title"
              [(ngModel)]="title"
            />
          </div>

          <div class="form-group">
            <label class="label">
              <a (click)="openCatalog('units')" class="text-primary link">
                <nb-icon icon="menu-2-outline"></nb-icon>
                {{ "product.unit" | translate }}
              </a>
              <span *ngIf="product.unitName && !product.unitId">
                : {{ product.unitName }}
              </span>
            </label>
            <nb-form-field fullWidth>
              <button
                nbPrefix
                nbButton
                ghost
                size="small"
                status="danger"
                (click)="removeCatalog('units')"
              >
                <nb-icon icon="close-outline"></nb-icon>
              </button>
              <nb-select
                [(ngModel)]="product.unitId"
                formControlName="unitName"
                class="type-select"
                size="small"
                fullWidth
              >
                <nb-option *ngFor="let opt of units" [value]="opt.id">{{
                  opt.title
                }}</nb-option>
              </nb-select>
            </nb-form-field>
          </div>

          <div *ngIf="user.purchase" class="form-group">
            <label class="label text-primary">
              {{ "product.costPrice" | translate }}:
              <!-- <span class="text-danger">
                {{ product.costPrice | number }}
              </span> -->
            </label>
            <input
              type="text"
              nbInput
              fullWidth
              class="form-control"
              placeholder="{{ 'product.costPrice' | translate }}"
              id="costPrice"
              formControlName="costPrice"
              [(ngModel)]="product.costPrice"
              [ngxNumberFormat]="formatCurrency"
            />
          </div>

          <div *ngIf="product.costPrice > 0" class="form-group">
            <label class="label text-primary"> % giá bán: </label>

            <a (click)="calculatorPrice(50)" class="text-danger link text-link">
              <strong> 50% </strong>
            </a>
            <a (click)="calculatorPrice(40)" class="text-danger link text-link">
              <strong> 40% </strong>
            </a>
            <a (click)="calculatorPrice(35)" class="text-danger link text-link">
              <strong> 35% </strong>
            </a>
            <a (click)="calculatorPrice(30)" class="text-danger link text-link">
              <strong> 30% </strong>
            </a>
            <a (click)="calculatorPrice(20)" class="text-danger link text-link">
              <strong> 20% </strong>
            </a>
            <input
              type="number"
              nbInput
              class="form-control"
              id="ratePrice"
              formControlName="ratePrice"
              [(ngModel)]="ratePrice"
              (keydown.enter)="calculatorPrice(ratePrice)"
            />
          </div>

          <div class="form-group">
            <label class="label text-primary">
              {{ "product.price" | translate }}:
              <!-- <span class="text-danger">{{ product.price | number }} </span> -->
            </label>
            <input
              type="text"
              nbInput
              fullWidth
              class="form-control"
              placeholder="{{ 'product.price' | translate }}"
              id="price"
              formControlName="price"
              [(ngModel)]="product.price"
              [ngxNumberFormat]="formatCurrency"
            />
          </div>
          <!-- <div class="form-group">
            <label class="label text-primary">
              {{ "product.wsPrice" | translate }}:              
            </label>
            <input
              type="text"
              nbInput
              fullWidth
              class="form-control"
              placeholder="{{ 'product.wsPrice' | translate }}"
              id="wsPrice"
              formControlName="wsPrice"
              [(ngModel)]="product.wsPrice"
              [ngxNumberFormat]="formatCurrency"
            />
          </div> -->
          <div class="form-group">
            <label class="label text-primary">
              <nb-checkbox
                status="warning"
                formControlName="isStock"
                [(ngModel)]="product.isStock"
              >
                Quản lý tồn kho
              </nb-checkbox>
            </label>
            <div *ngIf="product.isStock" class="stock-warning">
              <input
                type="number"
                nbInput
                status="info"
                class="form-control"
                placeholder="Tồn thấp nhất"
                formControlName="stockMin"
                [(ngModel)]="product.stockMin"
              />
              <input
                type="number"
                nbInput
                status="danger"
                class="form-control"
                placeholder="Tồn lớn nhất"
                formControlName="stockMax"
                [(ngModel)]="product.stockMax"
              />
            </div>
          </div>

          <div class="form-group">
            <div class="label">
              <label>{{ "common.note" | translate }}</label>

              <label *ngIf="user.language !== 'vn'" class="label">
                <a (click)="translate()" class="text-primary link">
                  <nb-icon icon="globe-outline"></nb-icon>
                  Translate
                </a>
              </label>
            </div>

            <textarea
              nbInput
              fullWidth
              rows="5"
              id="inputDescription"
              placeholder="{{ 'common.note' | translate }}"
              class="form-control"
              formControlName="description"
              [(ngModel)]="product.description"
            ></textarea>
          </div>
        </form>
      </div>

      <div class="col-12 col-md-6">
        <div class="form-group">
          <label class="label">
            <a (click)="openCatalog('groups')" class="text-primary link">
              <nb-icon icon="menu-2-outline"></nb-icon>
              {{ "common.groups" | translate }}
            </a>
          </label>
          <nb-form-field fullWidth>
            <button
              nbPrefix
              nbButton
              ghost
              size="small"
              status="danger"
              (click)="removeCatalog('groups')"
            >
              <nb-icon icon="close-outline"></nb-icon>
            </button>
            <nb-select
              [(ngModel)]="product.groupId"
              class="type-select"
              size="small"
              fullWidth
            >
              <nb-option *ngFor="let opt of groups" [value]="opt.id">{{
                opt.title
              }}</nb-option>
            </nb-select>
          </nb-form-field>
        </div>
        <div class="form-group">
          <label class="label">
            <a (click)="openCatalog('categories')" class="text-primary link">
              <nb-icon icon="menu-2-outline"></nb-icon>
              {{ "common.categories" | translate }}
            </a>
          </label>
          <nb-form-field fullWidth>
            <button
              nbPrefix
              nbButton
              ghost
              size="small"
              status="danger"
              (click)="removeCatalog('categories')"
            >
              <nb-icon icon="close-outline"></nb-icon>
            </button>
            <nb-select
              [(ngModel)]="product.categoryId"
              class="type-select"
              size="small"
              fullWidth
            >
              <nb-option *ngFor="let opt of categories" [value]="opt.id">{{
                opt.title
              }}</nb-option>
            </nb-select>
          </nb-form-field>
        </div>

        <div class="form-group">
          <label class="label">
            <a (click)="openCatalog('producers')" class="text-primary link">
              <nb-icon icon="menu-2-outline"></nb-icon>
              {{ "common.producers" | translate }}
            </a>
          </label>
          <nb-form-field fullWidth>
            <button
              nbPrefix
              nbButton
              ghost
              size="small"
              status="danger"
              (click)="removeCatalog('producers')"
            >
              <nb-icon icon="close-outline"></nb-icon>
            </button>
            <nb-select
              [(ngModel)]="product.producerId"
              class="type-select"
              size="small"
              fullWidth
            >
              <nb-option *ngFor="let opt of producers" [value]="opt.id">{{
                opt.title
              }}</nb-option>
            </nb-select>
          </nb-form-field>
        </div>
        <div class="form-group">
          <label class="label">
            <a (click)="openCatalog('origins')" class="text-primary link">
              <nb-icon icon="menu-2-outline"></nb-icon>
              {{ "common.origins" | translate }}
            </a>
          </label>
          <nb-form-field fullWidth>
            <button
              nbPrefix
              nbButton
              ghost
              size="small"
              status="danger"
              (click)="removeCatalog('origins')"
            >
              <nb-icon icon="close-outline"></nb-icon>
            </button>
            <nb-select
              [(ngModel)]="product.originId"
              class="type-select"
              size="small"
              fullWidth
            >
              <nb-option *ngFor="let opt of origins" [value]="opt.id">{{
                opt.title
              }}</nb-option>
            </nb-select>
          </nb-form-field>
        </div>
        <div class="form-group">
          <label class="label">
            <a (click)="openCatalog('sizes')" class="text-primary link">
              <nb-icon icon="menu-2-outline"></nb-icon>
              {{ "common.sizes" | translate }}
            </a>
          </label>
          <nb-form-field fullWidth>
            <button
              nbPrefix
              nbButton
              ghost
              size="small"
              status="danger"
              (click)="removeCatalog('sizes')"
            >
              <nb-icon icon="close-outline"></nb-icon>
            </button>
            <nb-select
              [(ngModel)]="product.sizeId"
              class="type-select"
              size="small"
              fullWidth
            >
              <nb-option *ngFor="let opt of sizes" [value]="opt.id">{{
                opt.title
              }}</nb-option>
            </nb-select>
          </nb-form-field>
        </div>
        <div class="form-group">
          <label class="label">
            <a (click)="openCatalog('colors')" class="text-primary link">
              <nb-icon icon="menu-2-outline"></nb-icon>
              {{ "common.colors" | translate }}
            </a>
          </label>
          <nb-form-field fullWidth>
            <button
              nbPrefix
              nbButton
              ghost
              size="small"
              status="danger"
              (click)="removeCatalog('colors')"
            >
              <nb-icon icon="close-outline"></nb-icon>
            </button>
            <nb-select
              [(ngModel)]="product.colorId"
              class="type-select"
              size="small"
              fullWidth
            >
              <nb-option *ngFor="let opt of colors" [value]="opt.id">{{
                opt.title
              }}</nb-option>
            </nb-select>
          </nb-form-field>
        </div>

        <div class="form-group">
          <label class="label">{{ "common.tags" | translate }}</label>
          <nb-tag-list (tagRemove)="onTagRemove($event)">
            <nb-tag *ngFor="let tree of trees" [text]="tree" removable></nb-tag>
            <input
              type="text"
              nbTagInput
              (tagAdd)="onTagAdd($event)"
              fullWidth
            />
          </nb-tag-list>
        </div>

        <div class="form-group">
          <div class="label">
            <label>EXP Note</label>
          </div>
          <textarea
            nbInput
            fullWidth
            rows="5"
            id="inputExp"
            class="form-control"
            [(ngModel)]="product.note1"
          ></textarea>
        </div>

        <div class="form-group">
          <div class="label">
            <label>Detail Note</label>
          </div>
          <textarea
            nbInput
            fullWidth
            rows="5"
            id="inputDetailNote"
            class="form-control"
            [(ngModel)]="product.note2"
          ></textarea>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="menu == 'content'">
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label class="label"> Tài liệu giới thiệu </label>
          <ngx-editor-document
            [(ngModel)]="product.content"
          ></ngx-editor-document>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label class="label">
            Hình đại diện
            <button
              nbButton
              ghost
              size="none"
              status="danger"
              [disabled]="submitted"
              [class.btn-pulse]="submitted"
              (click)="removeCoverUrl()"
            >
              <nb-icon icon="trash-2-outline"></nb-icon>
            </button>
          </label>
          <ngx-upload-image
            [size]="'tiny'"
            [mode]="'imagekit'"
            [path]="'/product/cover'"
            [imageURL]="imageURL"
            (onUploadSuccess)="updateImage($event)"
          ></ngx-upload-image>
        </div>

        <div class="form-group">
          <label class="label">Video giới thiệu</label>
          <ngx-view-video [url]="product.videoUrl"></ngx-view-video>
          <input
            nbInput
            fullWidth
            placeholder="Nhập liên kết"
            class="form-control"
            [(ngModel)]="product.videoUrl"
          />
        </div>
      </div>
    </div>

    <div *ngIf="menu == 'content'" class="row">
      <div class="col-12">
        <div class="form-group">
          <label class="label"> Hình ảnh sản phẩm</label>
          <nb-card>
            <nb-card-header>
              <button
                nbButton
                outline
                status="info"
                size="small"
                [disabled]="submitted"
                [class.btn-pulse]="submitted"
                (click)="openGallery()"
              >
                <nb-icon icon="image-outline"></nb-icon>
                Chọn hình ảnh
              </button>
            </nb-card-header>
            <nb-card-body class="container">
              <div class="row">
                <div
                  class="column"
                  *ngFor="let item of imagesUrl; let i = index"
                >
                  <button
                    nbButton
                    outline
                    fullWidth
                    status="danger"
                    size="tiny"
                    [disabled]="submitted"
                    [class.btn-pulse]="submitted"
                    (click)="deleteImage(item)"
                  >
                    <nb-icon icon="trash-2-outline"></nb-icon>
                  </button>
                  <img [src]="item" style="width: 100%" />
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button
      type="submit"
      nbButton
      hero
      status="primary"
      size="small"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
      (click)="submit(false)"
    >
      {{ "buttons.save" | translate }}
    </button>

    <button
      type="submit"
      nbButton
      hero
      status="success"
      size="small"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
      (click)="submit(true)"
    >
      {{ "buttons.save" | translate }} & {{ "buttons.create" | translate }}
    </button>

    <button
      nbButton
      hero
      status="danger"
      size="small"
      [disabled]="submitted"
      [class.btn-pulse]="submitted"
      (click)="delete()"
    >
      <nb-icon icon="trash-2-outline"></nb-icon>
      Xóa
    </button>
  </nb-card-footer>
</nb-card>
